var exports = {
  "$P": "x4ddf2309--a41282--search",
  "Xv": "x4ddf2309--a41282--results",
  "p_": "x4ddf2309--a41282--list",
  "AS": "x4ddf2309--a41282--item",
  "Ov": "x4ddf2309--a41282--item-text",
};

module.exports = exports;
